// Swaps the homepage hero's decorative holo-card for a real product,
// so a different real find greets every visit instead of a fixed
// placeholder card. Falls back to the decorative card untouched when no
// collection is set or the fetch turns up nothing.
//
// SQUARE PHOTOS GET A SQUARE FRAME (2026-10-09): the hero frame is a tall
// card shape (290x404) with the photo set to object-fit: cover, right for a
// card and wrong for a video game, whose photos are 1600x1600 squares. A
// Quest 64 box and Banjo-Kazooie were cut off in the hero (AJ). The feed now
// sends each photo's width/height ratio; anything wider than SQUARE_FROM
// (0.9) gets a square frame and object-fit: contain, so the whole photo
// shows. Cards (about 0.72) keep the card frame untouched. Done with inline
// styles on purpose so no stylesheet has to change.
//
// TOP OF THE CATALOGUE, NOT THE WHOLE THING (2026-10-06): AJ saw a holo
// Energy in the hero and asked for the pick to come from the top 100 or so
// highest-priced items instead. The pool collection
// (all-products-hero-feed) is now sorted PRICE_DESC in Shopify admin, and
// the feed paginates 50 per page, so pages 1 and 2 ARE the top 100. The
// random page is now drawn from the first TOP_PAGES pages only. Sold-out
// and photo-less products are already dropped by the feed template, so
// the real pool is "top 100 by price, minus whatever sold", a little under
// 100. If the collection's sort is ever changed away from PRICE_DESC this
// silently turns back into "random from the first 100 in that order", so
// check the collection's sort before blaming this file.
//
// RANDOM PAGE, NOT SORT OVERRIDE (2026-08-26, replaced same day): the first
// two versions of this fix tried to decouple the hero's pool from the
// Catalog page's sort via `?sort_by=...`. That worked once, then started
// returning an empty array for some sort values (created-descending,
// best-selling) while others (title-ascending, none) kept working —
// undocumented, inconsistent Shopify behavior on an alternate template
// view, not worth depending on. Replaced with plain Shopify pagination:
// fetch page 1 to learn how many pages exist, then fetch a random page and
// pick from THAT. Still the mechanism here; only the page range changed.
//
// LOAD-BEFORE-SWAP: the picked photo is preloaded in memory (a plain
// Image()) before anything touches the DOM, so the page goes straight from
// the colorful placeholder to the finished photo with no gap in between —
// see paintHero/initHero below. AJ caught an earlier version flashing solid
// black while the photo downloaded.
(function () {
  // Pages of 50 to draw from, counted from the top of the pool collection.
  // 2 pages = the 100 highest-priced items. Raise it to widen the pool.
  var TOP_PAGES = 2;

  // Photos with width/height above this get a square frame (see header).
  var SQUARE_FROM = 0.9;
  var SQUARE_FRAME_WIDTH = '340px';

  function paintHero(wrap, pick) {
    var card = wrap.querySelector('.vault-holo-card');
    var face = wrap.querySelector('.vault-holo-face');
    if (!card || !face) return;

    card.classList.add('vault-holo-card--photo');

    var ratio = parseFloat(pick.ratio);
    var squareFrame = ratio > SQUARE_FROM;
    if (squareFrame) {
      // Width stays capped by the theme's max-width: 100%, so on a narrow
      // phone the frame shrinks and the height follows the aspect ratio.
      card.style.width = SQUARE_FRAME_WIDTH;
      card.style.height = 'auto';
      card.style.aspectRatio = '1 / 1';
    }

    var gradeTag = card.querySelector('.vault-holo-grade-tag');
    if (gradeTag) gradeTag.remove();

    face.className = 'vault-holo-face vault-holo-face--photo';
    face.innerHTML = '';
    var photoWrap = document.createElement('div');
    photoWrap.className = 'vault-holo-photo';
    var img = document.createElement('img');
    img.className = 'vault-holo-photo-img';
    img.loading = 'lazy';
    img.alt = pick.title;
    img.src = pick.image;
    if (squareFrame) img.style.objectFit = 'contain';
    photoWrap.appendChild(img);
    face.appendChild(photoWrap);

    var stage = wrap.querySelector('.vault-stage');
    if (stage && stage.parentNode) {
      var link = document.createElement('a');
      link.href = pick.url;
      link.setAttribute('aria-label', pick.title + ', ' + pick.price);
      link.className = 'vault-hero-holo-link';
      stage.parentNode.insertBefore(link, stage);
      link.appendChild(stage);
    }

    var caption = wrap.querySelector('.vault-stage-caption');
    var captionText = pick.title + ' — ' + pick.price + ' · today’s featured find';
    if (caption) {
      caption.textContent = captionText;
    } else {
      caption = document.createElement('div');
      caption.className = 'vault-stage-caption';
      caption.textContent = captionText;
      wrap.appendChild(caption);
    }
  }

  function pickAndPaint(wrap, items) {
    var withImages = items.filter(function (p) { return p && p.image; });
    if (!withImages.length) return;
    var pick = withImages[Math.floor(Math.random() * withImages.length)];

    var preload = new Image();
    preload.onload = function () {
      paintHero(wrap, pick);
    };
    preload.onerror = function () {
      /* leave the decorative placeholder exactly as server-rendered */
    };
    preload.src = pick.image;
  }

  function initHero(wrap) {
    if (wrap.dataset.heroInit) return;
    wrap.dataset.heroInit = 'true';

    var poolUrl = wrap.dataset.heroPoolUrl;
    if (!poolUrl) return;

    fetch(poolUrl + '&page=1')
      .then(function (r) { return r.json(); })
      .then(function (firstPage) {
        var totalPages = firstPage && firstPage.total_pages ? firstPage.total_pages : 1;
        var firstItems = (firstPage && firstPage.items) || [];

        // Only the top of the (price-sorted) pool is in play.
        var pagesInPlay = Math.min(totalPages, TOP_PAGES);

        if (pagesInPlay <= 1) {
          pickAndPaint(wrap, firstItems);
          return;
        }

        var randomPage = 1 + Math.floor(Math.random() * pagesInPlay);
        if (randomPage === 1) {
          pickAndPaint(wrap, firstItems);
          return;
        }

        fetch(poolUrl + '&page=' + randomPage)
          .then(function (r) { return r.json(); })
          .then(function (page) {
            var items = (page && page.items) || [];
            // A page can legitimately have zero in-stock/photographed items
            // (e.g. every card on that page happens to be sold). Fall back
            // to page 1's items rather than leaving the placeholder up.
            pickAndPaint(wrap, items.length ? items : firstItems);
          })
          .catch(function () {
            pickAndPaint(wrap, firstItems);
          });
      })
      .catch(function () {
        /* leave the decorative fallback card exactly as server-rendered */
      });
  }

  function init() {
    document.querySelectorAll('[data-vault-random-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
